import React, { useState, useCallback, useEffect } from "react";
import { Box, Button, Stack, TextField, Autocomplete } from "@mui/material";
import { getEventNotificationReminderTime, updateEventNotificationReminderTime } from "../../Requests/EventNotificationReminderTimeService.ts";
import { getMembershipExpirationReminderTime, updateMembershipExpirationReminderTime } from "../../Requests/MembershipExpirationReminderTimeService.ts";


export default function NotificationTimeBeforeEventView() {
  const hoursOptions: number[] = [1, 2, 3, 4, 5]
  const membershipHoursOptions: number[] = [1, 2, 3, 4, 5, 168, 336, 504, 720]

  const [oldEventNotificationHours, setOldEventNotificationHours] = useState<number | null>(null)
  const [eventNotificationHours, setEventNotificationHours] = useState<number | null>(null)

  const [oldMembershipNotificationHours, setOldMembershipNotificationHours] = useState<number | null>(null)
  const [membershipNotificationHours, setMembershipNotificationHours] = useState<number | null>(null)

  const handleSaveTap = async (): Promise<void> => {
    const promises: Promise<void>[] = []

    if (eventNotificationHours !== null && eventNotificationHours !== oldEventNotificationHours) {
      promises.push(updateEventNotificationReminderTime(eventNotificationHours))
    }

    if (membershipNotificationHours !== null && membershipNotificationHours !== oldMembershipNotificationHours) {
      promises.push(updateMembershipExpirationReminderTime(membershipNotificationHours))
    }

    try {
      await Promise.all(promises)
      alert("Saved")
    } catch (error) {
      console.error("Save error:", error)
      alert("Error saving changes")
    }
  }

  const fetchData = useCallback(async (): Promise<void> => {
    try {
      const eventHours = await getEventNotificationReminderTime()
      setOldEventNotificationHours(eventHours?.hours ?? null)
      setEventNotificationHours(eventHours?.hours ?? null)
    } catch {
      console.log("getEventNotificationReminderTime fetch error")
    }

    try {
      const membershipHours = await getMembershipExpirationReminderTime()
      setOldMembershipNotificationHours(membershipHours?.hours ?? null)
      setMembershipNotificationHours(membershipHours?.hours ?? null)
    } catch {
      console.log("getMembershipExpirationReminderTime fetch error")
    }
  }, [])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  const handleHoursChange = (
    setter: React.Dispatch<React.SetStateAction<number | null>>
  ) => (value: number | null) => {
    if (value !== null) {
      setter(value)
    }
  }

  const formatHourLabel = (hour: number): string => {
    switch (hour) {
      case 168: return "1 week"
      case 336: return "2 weeks"
      case 504: return "3 weeks"
      case 720: return "1 month"
      default: return `${hour} hour${hour === 1 ? "" : "s"}`
    }
  }

  return (
    <>
      <Box>
        <Stack
          spacing={1}
          marginTop={4}
        >
          <Autocomplete
            options={hoursOptions}
            value={eventNotificationHours}
            onChange={(_, value) => handleHoursChange(setEventNotificationHours)(value)}
            getOptionLabel={formatHourLabel}
            renderInput={(params) => (
              <TextField {...params} label="How many hours before the event should I send a notification?" />
            )}
          />
        </Stack>

        <Stack
          spacing={1}
          marginTop={4}
        >
          <Autocomplete
            options={membershipHoursOptions}
            value={membershipNotificationHours}
            onChange={(_, value) => handleHoursChange(setMembershipNotificationHours)(value)}
            getOptionLabel={formatHourLabel}
            renderInput={(params) => (
              <TextField {...params} label="How much time before membership expiration should I send a notice?" />
            )}
          />
        </Stack>
      </Box>

      <Box
        display="flex"
        justifyContent="right"
        marginTop={4}
      >
        <Button
          variant="contained"
          size="large"
          onClick={() => handleSaveTap()}
        >
          {"Save"}
        </Button>
      </Box>
    </>
  )
}
